import request from '@/utils/request';
/**
 * 返回体
 * code 1 成功 0 失败
 */
// 查询淘宝订单同步状态接口
export function queryTbOrderSyncProApi(data) {
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/order/getSynOrderFlag',
    method: 'POST',
    data
  });
}
/**
 * 获取列表数据接口
 * @param {*} data
 * @param {*} func：
 * 不合并订单：listOrder | 自动合并订单：getAllOrdersNew
 */
 export function getTbAllOrdersApi(data, func = 'getAllOrdersNew') {
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/order/' + func,
    method: 'POST',
    data
  });
}
// 查询统计数据接口
export function syncTbStatisticApi(data) {
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/order/statistic',
    method: 'POST',
    data
  });
}
// 查询淘宝、1688店铺列表与授权状态接口
export function getTbAliStoreListApi(data){
  return request({
    baseURL: '/tb-api/',
    url: '/commonMall/queryMall',
    method: 'post',
    data
  });
}
// 按orderId更新订单接口
export function syncTbOrderByOrderIdApi(data) {
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/order/synOrderByOrderId',
    method: 'POST',
    data
  });
}
// 按时间段更新订单接口
export function syncTbTimeSlotOrdersApi(data) {
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/order/synTimeSlotOrders',
    method: 'POST',
    data
  });
}
// 获取高级查询列表项接口
export function syncTbAdvancedQueryListApi(data) {
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/advancedQuery/list',
    method: 'post',
    data
  });
}
// 添加&修改高级查询项接口
export function syncTbSaveAdvancedQueryApi(data) {
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/advancedQuery/save',
    method: 'POST',
    data
  });
}
// 删除高级查询项接口
export function syncTbDelAdvancedQueryApi(data) {
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/advancedQuery/del',
    method: 'post',
    data
  });
}
// 获取商品名称数据接口
export function syncTbProductListApi(data) {
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/product/productList',
    method: 'POST',
    data
  });
}
export function tbGetAllOrderNewProductApi(data) {
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/product/getAllOrderNewProduct',
    method: 'POST',
    data
  });
}
// 获取商品规格数据接口
export function syncTbSkuListApi(data) {
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/product/productSkuList',
    method: 'POST',
    data
  });
}
// 设置商品简称接口
export function syncTbUpdateProductAliasApi(data) {
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/product/updateTaobaoProductAlias',
    method: 'POST',
    data
  });
}
// 客户管家-淘宝拉单新接口
export function getTbApplyOrdersApi(data){
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/order/applyWaybill',
    method: 'POST',
    data
  });
}
/**
 * 没修改
 * 淘宝发货接口
 * @param {*} data
 * @param {*} func : shipmentsSend-发货 | shipmentsReSend-重新发货
 */
export function syncTbSendGoodsApi(data, func) {
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/order/' + func,
    method: 'POST',
    data
  });
}
// 更新发货单状态接口
export function syncTbUpdateDeliverStatusApi(data){
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/applyOrders/updateDeliverStatus',
    method: 'POST',
    data
  });
}
// 自定义列配置修改 修改导出设置
export function addTbUserColumnConfigApi(data) {
  return request({
    baseURL: '/tb-api/',
    url: '/columnConfig/addUserColumnConfig',
    method: 'POST',
    data
  });
}
// 自定义列配置查询 导出设置
export function queryTbUserColumnConfigApi(data) {
  return request({
    baseURL: '/tb-api/',
    url: '/columnConfig/queryUserColumnConfig',
    method: 'POST',
    data
  });
}
// 重置列配置
export function resetTbMallColumnConfigApi(data) {
  return request({
    baseURL: '/tb-api/',
    url: '/columnConfig/resetUserColumnConfig',
    method: 'POST',
    data
  });
}
// 手动合单
export function mergeTbOrderApi(data) {
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/order/mergeOrder',
    method: 'POST',
    data
  });
}
// 手动拆单-拆子单接口
export function splitTbOrderApi(data) {
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/order/splitOrder',
    method: 'POST',
    data
  });
}
// 自动合单拆分 - 交易单
export function splitTbOrderAllApi(data) {
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/order/splitOrderAll',
    method: 'POST',
    data
  });
}
// 自动合并列表所有待合（入参：无参）
export function mergeTbOrderAllApi(data) {
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/order/mergeOrderAll',
    method: 'POST',
    data
  });
}
// 查询待合列表接口
export function getPreMergeTbOrderApi(data) {
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/order/getPreMergeList',
    method: 'POST',
    data
  });
}
// 自动拆分所有合并未打印订单 拆单接口 （入参：无参）
export function splitUserTbOrderAllApi(data) {
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/order/splitUserAllOrder',
    method: 'POST',
    data
  });
}
// 查询历史老单号记录接口
export function getTbCanSelectOrderMailNoListApi(data) {
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/order/getOrderOldWaybillNoList',
    method: 'POST',
    data
  });
}
/**
 * 修改收件人信息 & 备注接口
 * 淘宝旺旺昵称字段buyerNick必传
 * 修改备注时传id、buyerMemo、sellerMemo字段 | 修改收件人信息时传id、和receiver开头的字段
 */
export function syncTbReceiverInfoApi(data) {
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/order/updateReceiverRemarkInfo',
    method: 'POST',
    data
  });
}
// 更新卖家备注(备注内容和旗帜) - 新
export function syncTbUpdateSellerMemoApi(data) {
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/order/updateSellerMemo',
    method: 'POST',
    data
  });
}
// 批量|单个 订单锁定 & 解锁接口
export function syncTbLockOrdersApi(data){
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/order/lockOrders',
    method: 'POST',
    data
  });
}
// 查询打印次数列表接口
export function queryTbPrintCountListApi(data) {
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/order/getOrderPrintHist',
    method: 'POST',
    data
  });
}
// 导出数据
export function syncTbExportOrderApi(data){
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/order/export',
    method: 'POST',
    responseType: 'blob',
    data
  });
}
// 同步订单
export function syncTbOrdersByManualApi(data) {
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/order/orderSync/' + data,
    method: 'post'
  })
}
// 订单查询店铺是否授权
export function tbMallIfAuthorizedApi(data) {
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/order/mallIfAuthorized',
    method: 'post',
    data
  });
}
// 打单前不可达地址校验
export function valiAddressInfoApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/addressUnArrive/printAddressArriveCheck',
    method: 'post',
    data
  });
}
// 选择订单-拆单接口
export function splitBatchOrderApi(data) {
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/order/splitBatchOrder',
    method: 'post',
    data
  });
}
// 更新圆通优选时效的接口
export function tbYtoPerferTimeFlagSynApi(data) {
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/order/ytoPerferTimeFlagSyn',
    method: 'post',
    data
  });
}
// 保存管家备注接口
export function updateTaobaoKhgjRemarkApi(data) {
  return request({
    baseURL: '/tb-api/taobao/',
    url: '/order/updateKhgjRemark',
    method: 'post',
    data
  });
}
